import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { unwrapPagedList } from './paged-list';
import { PermitUser, PermitUserSearchRequest } from '../../shared/models/permit-user';

@Injectable({ providedIn: 'root' })
export class PermitUserService {
  constructor(private readonly http: HttpClient) {}

  search(request: PermitUserSearchRequest = { Page: 1, PageSize: 50 }) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/PermitUserListSearch`, request).pipe(
      map(raw => unwrapPagedList<PermitUser>(raw))
    );
  }
}
